var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filters && _vm.filters.length > 0)?_c('div',{key:_vm.dummy,staticClass:"is-flex"},_vm._l((_vm.filters),function(filter){return _c('multiple-filter',{key:filter.designator,attrs:{"payload":filter}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }